import Breakpoint from 'bootstrap-breakpoints'

Breakpoint.init()

export default Breakpoint
